import { render, staticRenderFns } from "./KolonneSettingsEmployeesRankingLegend.vue?vue&type=template&id=5974b380"
import script from "./KolonneSettingsEmployeesRankingLegend.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsEmployeesRankingLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports